module.exports = __webpack_public_path__ + "../static/media/perfil.be3a165a.png";